/* @flow */

import * as React from 'react';
import './mfa-secondary.module.css';

type Props = {
    children?: React.Node,
    as: string,
};

MfaSecondary.defaultProps = {
    as: 'div',
};

export function MfaSecondary({children, as: Tag}: Props) {
    return <Tag styleName='mfa-secondary'>{children}</Tag>;
}
